/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H133162 on 2/4/2021.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Button, Card, Grid, Icon, Modal, TextArea, Tooltip} from '@scuf/common';
import * as FaultActions from "../FaultActions";
import * as SecurityActions from '../../security/SecurityActions'
import Loader from '../../common/Loader'
import {formatDateTime} from "../../common/LocaleHelper";
import {FAULT_STATES, isClosedState} from "./FaultsConst";
import {immutableFaultState} from "./FaultsUtils";
import ExpandableCard from "../../common/ExpandableCard";
import ConfigurationSymptoms from "../ConfigurationSymptoms";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import ActionLogTable from "./ActionLogTable";
import CommentsTable from "../troubleshooting/CommentsTable";
import workflowImageEn from "../../styling/images/workflow-en.png";
import {getCurrentLanguage, verifyAirtimeException} from "../../utils/Helpers";
import workflowImageZh from "../../styling/images/workflow-zh.png";
import {reexportLLPacket} from "../../admin/learningLoop/LearningLoopActions";
import {showNotification} from "../../common/ToastNotification";
import {Link} from "react-router-dom";
import momentTz from "moment-timezone";

class PRInfoModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            comment: '',
            commentsLoading: false,
            workflowModalOpen: false,
            editingDisabled: true,
        }

        this.handleSaveComment = this.handleSaveComment.bind(this)
        this.handleUpdateComment = this.handleUpdateComment.bind(this)
    }

    componentDidMount() {
        const {fault} = this.props
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.fetchActionLog(fault.assetId, fault.faultId, external)
    }

    reloadComments(id) {
        this.setState({commentsLoading: true})
        return this.props.FaultActions.fetchComments(this.props.fault.assetId, id, userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
            this.setState({commentsLoading: false})
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    handleSaveComment() {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.saveComment(this.props.fault.assetId, this.props.fault.faultId, this.state.comment, external)
            .then(() => {
                this.reloadComments(this.props.fault.faultId).then(() => {
                    this.setState({comment: ''})
                })
            }).then(() => {
            reexportLLPacket(this.props.fault, external)
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    handleUpdateComment(id, text, commentSaved) {
        const external = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        this.props.FaultActions.updateComment(this.props.fault.assetId, this.props.fault.faultId, id, text, external)
            .then(() => {
                this.reloadComments(this.props.fault.faultId);
                commentSaved()
            }).then(() => {
            reexportLLPacket(this.props.fault, external)
        }).catch(err => {
            verifyAirtimeException(err.errorKey, this.props.SecurityActions.signOut)
            showNotification({
                translationPropertyKey: 'fault.detail.comment.save.' + err.errorKey,
                severity: "critical",
            })
        });
    }

    getReadOnlyStatus() {
        const {intl, fault} = this.props
        let text = '';
        if (fault.readOnly) {
            text = intl.formatMessage({id: "fault.detail.label.readonly"})
        }
        return <div className='fault-readonly-text'>{text}</div>
    }

    getSyptomsList(presentSymptoms, repeatFaults, assetId) {
        presentSymptoms = presentSymptoms.map(s => {
            let repeatFaultsForSymptom = null;
            if (repeatFaults != null && repeatFaults.length > 0) {
                repeatFaultsForSymptom =
                    this.getRepeatFaults(s, repeatFaults, assetId);
            }
            return <li key={s.id}>{s.name}{repeatFaultsForSymptom}</li>
        })
        return <ul>{presentSymptoms}</ul>
    }

    toTimeAgo(closeDateTime){
        // TO DO: Re-do for localization!!
        let difference = (new Date() - momentTz.tz(closeDateTime, 'UTC').toDate()) / 1000;
        let element = "";
        if (difference < 60) {
            element = "second";
        } else if (difference < (60*60)) {
            difference /= 60;
            element = "minute"
        } else if (difference < (60*60*24)) {
            difference /= (60*60);
            element = "hour"
        } else if (difference < (60*60*24*31)) {
            difference /= (60*60*24);
            element = "day"
        } else if (difference < (60*60*24*365)) {
            difference /= (60*60*24*31)
            element = "month"
        } else {
            difference /= (60*60*24*365)
            element = "year"
        }
        difference = Math.floor(difference);
        if (difference > 1) {
            element = element + "s"
        }
        return <FormattedMessage id={"fault.timeAgo." + element} values={{'difference': difference}}/>;
    }

    getRepeatFaults(symptom, repeatFaults, assetId) {
        const result = repeatFaults.map(rf => {
            if (rf.primarySymptom === symptom.id) {
                const path = userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ?
                    `/airtime/asset/${assetId}/faults/${rf.id}`
                    :
                    `/assets/${assetId}/faults/${rf.id}`

                return (
                    <div className="repeatFault-button">
                        <Link to={path} target="_self">
                            <Button type="link">{rf.name + ":" + symptom.name}</Button>
                        </Link>
                        <span className="timeAgo-message">
                            {this.toTimeAgo(rf.closeDateTime)}
                        </span>
                    </div>
                )
            } else {
                return null;
            }
        })
        if (result != null && result[0] != null) {
            return (
                <div>
                    <div className="icon-repeat">
                        <Icon className="yellow-icon" name="badge-info" exactSize={35}/>
                        <div className="yellow-text">
                            <FormattedMessage id={"fault.detail.repeatFault"}/>
                        </div>
                    </div>
                    {result}
                    <br/>
                </div>
            )
        }
        return null;
    }

    workflowLinkWithModal() {
        const {intl} = this.props
        let image = workflowImageEn
        if (getCurrentLanguage() === 'zh') {
            image = workflowImageZh
        }
        return (
            <div id="workflow-modal-link">
                (
                <Button type="link" content = {intl.formatMessage({id: 'fault.detail.state.workflow'})}
                        onClick={()=> this.setState({workflowModalOpen: true})} />
                <Modal closeIcon={true} onClose={() => this.setState({workflowModalOpen: false})} open={this.state.workflowModalOpen} closeOnDimmerClick={true} className="workflow-modal">
                    <Modal.Header>
                        <FormattedMessage id="fault.detail.label.workflow"/>
                    </Modal.Header>
                    <Modal.Content>
                        <img alt="workflow" src={image}/>
                    </Modal.Content>
                </Modal>
                )
            </div>
        )
    }

    render() {
        const {intl, fault, security} = this.props;

        let newFaultState = fault.details.faultConditionState
        if (fault.details.name.startsWith('Alert#') && (fault.details.faultConditionState === FAULT_STATES.NEW)) {
            newFaultState = FAULT_STATES.NEW_ALERT;
        }

        let reportedSymptoms = [];
        if (fault.details && fault.details.reportedSymptoms) {
            reportedSymptoms = fault.details.reportedSymptoms
        }

        let repeatFaults = [];
        if (fault.details && fault.details.repeatFaults) {
            repeatFaults = fault.details.repeatFaults
        }

        const locking = this.state.editingDisabled ? "locked" : "unlocked"

        const configButton =
            <div className="locking-button">
                <Button onClick={() => this.setState({editingDisabled: !this.state.editingDisabled})}
                        disabled={
                            fault.readOnly ||
                            !userHasActivity(security.userProfile, ACTIVITY_TYPES.CONFIG_SYMPTOMS_WRITE) ||
                            immutableFaultState(fault)
                        }
                        className="mobile-max-width-button"
                        type="secondary"
                >
                    {intl.formatMessage({id: 'fault.detail.title.configurationSymptoms.' + locking})}
                </Button>
            </div>

        return (
            <Modal closeIcon={false} onClose={() => this.props.closeModalWindow()} open={this.props.modalWindowOpen}
                   closeOnDimmerClick={true} className="closed-modal">
                <Modal.Header>
                    {fault.details.name + " " + fault.details.primarySymptom.name}
                </Modal.Header>
                <Modal.Content scrolling={true} className="modal--content">
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={12} sWidth={12}>
                                <Card className="general grid--card">
                                    <Card.Header title="General" />
                                    <Card.Content>
                                        <Grid>
                                            <Grid.Row>
                                                <Grid.Column width={5}>
                                                    <FormattedMessage id="fault.detail.label.primarysymptom" />
                                                </Grid.Column>
                                                <Grid.Column width={7}>
                                                    {fault.details && fault.details.primarySymptom ? fault.details.primarySymptom.name : ''}
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column width={5}>
                                                    <FormattedMessage id="fault.detail.label.state" />
                                                </Grid.Column>
                                                <Grid.Column width={7} className={'state-' + newFaultState}>
                                                    <div>
                                                        <div className='state-icon' />
                                                        <div className='state-name'>{newFaultState ? intl.formatMessage({id: "fault.detail.state." + newFaultState}) : ''}</div>
                                                        {this.getReadOnlyStatus()}
                                                        {this.workflowLinkWithModal()}
                                                    </div>
                                                </Grid.Column>
                                            </Grid.Row>
                                            {fault.details.assignedUser !== null ?
                                                <Grid.Row>
                                                    <Grid.Column width={5}>
                                                        <FormattedMessage id="fault.detail.label.user" />
                                                    </Grid.Column>
                                                    <Grid.Column width={7} >
                                                        <div>{fault.details.assignedUser.displayName}</div>
                                                    </Grid.Column>
                                                </Grid.Row>
                                                :
                                                ""
                                            }
                                            <Grid.Row>
                                                <Grid.Column width={5}>
                                                    <FormattedMessage id="fault.detail.label.created" />
                                                </Grid.Column>
                                                <Grid.Column width={7}>
                                                    {fault.details.created ? formatDateTime(fault.details.created) : ''}
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Row>
                                                <Grid.Column width={5}>
                                                    <FormattedMessage id="fault.detail.label.modified" />
                                                </Grid.Column>
                                                <Grid.Column width={7}>
                                                    {fault.details.modified ? formatDateTime(fault.details.modified) : ''}
                                                </Grid.Column>
                                            </Grid.Row>
                                            {
                                                isClosedState(fault.details.faultConditionState) ?
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <FormattedMessage id="fault.detail.label.closed" />
                                                        </Grid.Column>
                                                        <Grid.Column width={7}>
                                                            {fault.details.closed ? formatDateTime(fault.details.closed) : ''}
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    :
                                                    ''
                                            }
                                            {
                                                (fault.details.exportedLL) ?
                                                    <Grid.Row>
                                                        <Grid.Column width={5}>
                                                            <FormattedMessage id="fault.detail.label.exportedLL" />
                                                        </Grid.Column>
                                                        <Grid.Column width={7}>
                                                            <div>
                                                                {formatDateTime(fault.details.exportedLL)}
                                                            </div>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    :
                                                    ''
                                            }
                                        </Grid>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row id="reported-symptoms">
                            <Grid.Column width={12}>
                                <ExpandableCard className="grid--card" title={intl.formatMessage({id: "fault.detail.title.reportedsymptoms"})} content={this.getSyptomsList(reportedSymptoms, repeatFaults, fault.assetId)} expandable={reportedSymptoms.length > 5} />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row id="configuration-symptoms">
                            <Grid.Column width={12}>
                                <ExpandableCard className="grid--card"
                                                title={intl.formatMessage({id: "fault.detail.title.configurationSymptoms.onFault"})}
                                                content={
                                                    <ConfigurationSymptoms
                                                        configSymptoms={fault.details.configurationSymptoms}
                                                        disabled={this.state.editingDisabled}
                                                        fault={fault}
                                                    />
                                                }
                                                inTitleSection={
                                                    fault.details.configurationSymptoms != null &&
                                                    fault.details.configurationSymptoms.length > 0 ?
                                                        userHasActivity(security.userProfile, ACTIVITY_TYPES.CONFIG_SYMPTOMS_WRITE) &&
                                                        !immutableFaultState(fault) ?
                                                            configButton
                                                            :
                                                            <Tooltip
                                                                element={configButton}
                                                                content={intl.formatMessage({id: 'fault.detail.title.configurationSymptoms.noRights'})}
                                                                position="top center"
                                                            />
                                                        :
                                                        null
                                                }
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Footer>
                    <div className="closedModal-buttons">
                        <Button className="mobile-max-width-button"
                                content={intl.formatMessage({id: "fault.detail.action.close"})}
                                onClick={() => this.props.closeModalWindow()} size="medium" type="secondary"/>
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        loading: state.fault.fetchCount > 0,
        security: state.security,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(PRInfoModal)))